export default __webpack_public_path__ + "static/media/clown.f8683bfd.jpg";